<template>
  <CreateUpdateTemplate
    :routePreventDialog="routePreventDialog"
    :hasChanges="hasChanges"
    :customClass="'create-claim create-form'"
    v-if="getPermission('claim:create') || getPermission('claim:update')"
  >
    <template v-slot:header-title>
      <div class="d-flex justify-space-between">
        <v-tooltip top content-class="custom-top-tooltip">
          <template v-slot:activator="{ on, attrs }">
            <h1
              v-bind="attrs"
              v-on="on"
              class="form-title text-truncate d-flex align-baseline select-custom-data"
            >
              Claim for
              <div
                v-if="reEntityId"
                class="ml-3 form-title-link cursor-pointer text-h5"
                v-on:click="openEntityDialog"
              >
                {{ entityName }}
              </div>
              <div
                v-else
                class="ml-3 form-title-link cursor-pointer text-h5"
                v-on:click="openEntityDialog"
              >
                Select a Entity
                <v-icon large color="cyan">mdi-home-edit</v-icon>
              </div>
            </h1>
          </template>
          <span>Entity</span>
        </v-tooltip>

        <v-spacer></v-spacer>
        <v-chip
          label
          color="chip-custom-blue"
          outlined
          class="text-white p-3 mr-4"
          style="font-size: 21px !important; font-weight: 700"
        >
          <template>
            {{ dbClaim.barcode }}
          </template>
        </v-chip>
      </div>
    </template>
    <template v-slot:header-action>
      <div>
        <v-btn
          :disabled="formLoading"
          v-on:click="goBack()"
          class="custom-bold-button custom-grey-border"
          depressed
          >Cancel</v-btn
        >
        <v-btn
          class="custom-bold-button ml-4"
          depressed
          :disabled="
            !formValid ||
            formLoading ||
            pageLoading ||
            categoryDetails.draft_exists ||
            !dbClaim.entity_id ||
            !dbClaim.employee_id ||
            (Number(dbClaim.claim_type) === 2 && !dbClaim.visit) ||
            !dbClaim.user_id ||
            !dbClaim.claim_category ||
            !dbClaim.receipt_amount ||
            !dbClaim.date
              ? true
              : false
          "
          :loading="formLoading"
          v-on:click="validateJob()"
          color="cyan white--text"
        >
          {{ claim_Id > 0 ? "Update" : "Save" }}
        </v-btn>
      </div>
    </template>
    <template v-slot:body>
      <v-row>
        <v-col cols="12" md="3" class="pr-0 pt-0">
          <v-card class="rounded pa-4 h-100">
            <perfect-scrollbar
              :options="{ suppressScrollX: true }"
              class="scroll"
              style="max-height: calc(100vh - 180px); position: relative"
            >
              <v-form
                ref="createQuotationForm"
                v-model.trim="formValid"
                lazy-validation
                v-on:submit.stop.prevent="onSubmit()"
              >
                <div class="text-h6 px-2">Claim Summary</div>

                <table class="mt-0" width="100%">
                  <tbody>
                    <tr>
                      <td colspan="2" class="py-2">
                        <v-card
                          class="px-4 py-3 rounded-lg left-border-blue"
                          flat
                          style="background-color: #e3f2fd"
                        >
                          <div class="text-h6 font-weight-bold mb-4">
                            Employee Details
                          </div>

                          <div class="d-flex justify-space-between mb-2">
                            <div class="grey--text text--darken-1">Name</div>
                            <div class="font-weight-medium">
                              {{ selectedEmployee?.display_name || "—" }}
                            </div>
                          </div>

                          <div class="d-flex justify-space-between mb-2">
                            <div class="grey--text text--darken-1">Email</div>
                            <div class="font-weight-medium">
                              {{ selectedEmployee?.primary_email || "—" }}
                            </div>
                          </div>

                          <div class="d-flex justify-space-between">
                            <div class="grey--text text--darken-1">Phone</div>
                            <div class="font-weight-medium">
                              {{ selectedEmployee?.primary_phone || "—" }}
                            </div>
                          </div>
                        </v-card>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table class="mt-0" width="100%">
                  <tbody>
                    <tr>
                      <td colspan="2" class="py-2">
                        <v-card
                          class="px-4 py-3 rounded-lg left-border-green"
                          flat
                          style="background-color: #e8f5e9"
                        >
                          <div class="text-h6 font-weight-bold mb-4">
                            Approver Details
                          </div>
                          <div class="d-flex justify-space-between mb-2">
                            <div class="grey--text text--darken-1">Name</div>
                            <div class="font-weight-medium">
                              {{ selectedUser?.display_name || "—" }}
                            </div>
                          </div>
                          <div class="d-flex justify-space-between mb-2">
                            <div class="grey--text text--darken-1">Email</div>
                            <div class="font-weight-medium">
                              {{ selectedUser?.email || "—" }}
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="grey--text text--darken-1">Phone</div>
                            <div class="font-weight-medium">
                              {{ selectedUser?.phone || "—" }}
                            </div>
                          </div>
                        </v-card>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <v-card
                  class="px-4 py-3 mx-2 rounded-lg mt-2 left-border-purple"
                  flat
                  style="background-color: #f3e5f5"
                >
                  <div class="text-h6 font-weight-bold mb-4">
                    Category Details
                  </div>
                  <div class="d-flex justify-space-between mb-2">
                    <div class="grey--text text--darken-1 mr-2">Category</div>
                    <div class="font-weight-medium">
                      {{ selectedCategory?.claim_type || "—" }}
                    </div>
                  </div>
                  <div class="d-flex justify-space-between mb-4">
                    <div class="grey--text text--darken-1">Sub-Category</div>
                    <div class="font-weight-medium">
                      {{ selectedSubCategory?.name || "—" }}
                    </div>
                  </div>
                  <div class="d-flex justify-space-between mb-2">
                    <div class="grey--text text--darken-1">
                      Category Total Amount
                    </div>
                    <div class="font-weight-bold red--text">
                      RM {{ categoryDetails?.max_amount || "0.00" }}
                    </div>
                  </div>
                  <div class="d-flex justify-space-between mb-2">
                    <div class="grey--text text--darken-1">Total Claims</div>
                    <div class="font-weight-bold red--text">
                      RM {{ categoryDetails.total_claimed || "0.00" }}
                    </div>
                  </div>
                  <div class="d-flex justify-space-between mb-3">
                    <div class="grey--text text--darken-1">Receipt Amount</div>
                    <div class="font-weight-medium">
                      RM {{ dbClaim.receipt_amount || "0.00" }}
                    </div>
                  </div>

                  <v-divider class="my-3"></v-divider>
                  <div class="d-flex justify-space-between">
                    <div class="grey--text text--darken-1 font-weight-medium">
                      Total Available
                    </div>
                    <div class="font-weight-bold green--text text-h6">
                      RM{{ availableAmount || "0.00" }}
                    </div>
                  </div>
                </v-card>
                <v-card
                  v-if="Number(dbClaim.claim_type) === 2 && dbClaim.visit"
                  class="px-4 py-3 mx-2 rounded-lg mt-2 left-border-orange"
                  flat
                  style="background-color: #fefbf8"
                >
                  <div class="d-flex justify-space-between mb-2">
                    <div class="text-h6 font-weight-bold mb-4">
                      Visit Details
                    </div>
                    <v-chip
                      small
                      outlined
                      color="orange"
                      class="font-weight-medium"
                    >
                      {{ selectedVisit?.barcode || "-" }}
                    </v-chip>
                  </div>
                  <div class="d-flex justify-space-between mb-2">
                    <div class="grey--text text--darken-1">Title</div>
                    <div class="font-weight-medium">
                      {{ selectedVisit?.title || "—" }}
                    </div>
                  </div>
                  <!-- <div class="d-flex justify-space-between mb-2">
                    <div class="grey--text text--darken-1">Visit #</div>
                  </div> -->
                  <div class="d-flex justify-space-between mb-2">
                    <div class="grey--text text--darken-1">Status</div>
                    <div class="font-weight-medium">{{ visitStatusText }}</div>
                  </div>
                  <v-card
                    class="px-4 py-3 mx-2 rounded-lg mt-2"
                    flat
                    style="background-color: #f8eddd"
                    ><div class="font-weight-bold black--text mb-2">
                      Site Location
                    </div>
                    <div class="font-weight-medium mb-1">
                      {{ selectedVisit?.site_location?.name || "—" }}
                    </div>
                    <div class="grey--text text--darken-1 mb-3">
                      {{ selectedVisit?.site_location?.address || "—" }}
                    </div></v-card
                  >
                  <v-card
                    class="px-4 py-3 mx-2 rounded-lg mt-2"
                    flat
                    style="background-color: #f8eddd"
                    ><div class="font-weight-bold black--text mb-2">
                      Contact Person
                    </div>
                    <div class="d-flex align-center mb-2">
                      <div
                        class="grey--text text--darken-1 d-flex align-center"
                      >
                        <v-icon small class="mr-2">mdi-account-outline</v-icon>
                        {{ selectedVisit?.contact_person_details?.name || "—" }}
                      </div>
                    </div>

                    <div class="d-flex align-center mb-2">
                      <div
                        class="grey--text text--darken-1 d-flex align-center"
                      >
                        <v-icon small class="mr-2">mdi-email-outline</v-icon>
                        {{
                          selectedVisit?.contact_person_details?.email || "—"
                        }}
                      </div>
                    </div>

                    <div class="d-flex align-center">
                      <div
                        class="grey--text text--darken-1 d-flex align-center"
                      >
                        <v-icon small class="mr-2">mdi-phone-outline</v-icon>
                        {{
                          selectedVisit?.contact_person_details?.phone || "—"
                        }}
                      </div>
                    </div></v-card
                  >
                </v-card>
                <v-card
                  v-if="Number(dbClaim.claim_type) === 1 && dbClaim.project"
                  class="px-4 py-3 mx-2 rounded-lg mt-2 left-border-orange"
                  flat
                  style="background-color: #fefbf8"
                >
                  <div class="d-flex justify-space-between mb-2">
                    <div class="text-h6 font-weight-bold mb-4">
                      Project Details
                    </div>
                    <v-chip
                      small
                      outlined
                      color="orange"
                      class="font-weight-medium"
                    >
                      {{ selectedProject?.barcode || "—" }}
                    </v-chip>
                  </div>
                  <div class="d-flex justify-space-between mb-2">
                    <div class="grey--text text--darken-1">Title</div>
                    <div class="font-weight-medium">
                      {{ selectedProject?.name || "—" }}
                    </div>
                  </div>
                  <div class="d-flex justify-space-between mb-2">
                    <div class="grey--text text--darken-1">Reference #</div>
                    <div class="font-weight-medium">
                      {{ selectedProject?.reference || "—" }}
                    </div>
                  </div>
                  <div class="d-flex justify-space-between mb-4">
                    <div class="grey--text text--darken-1">Start Date</div>
                    <div class="font-weight-medium">
                      {{ formatDetailDate(selectedProject?.started_at) }}
                    </div>
                  </div>
                  <div class="d-flex justify-space-between mb-2">
                    <div class="grey--text text--darken-1">End Date</div>
                    <div class="font-weight-medium">
                      {{
                        formatDetailDate(
                          selectedProject?.finished_at ||
                            selectedProject?.deadline
                        )
                      }}
                    </div>
                  </div>
                </v-card>
              </v-form>
            </perfect-scrollbar>
          </v-card>
        </v-col>
        <v-col cols="12" md="9" class="pt-0">
          <v-layout class="d-block iv-custom-field">
            <v-container fluid class="pt-0">
              <v-card class="pa-3 rounded-lg">
                <v-btn-toggle
                  v-model="dbClaim.claim_type"
                  :mandatory="claim_Id === 0"
                  borderless
                  class="my-0 w-100 claim-tabs"
                  @change="onClaimTypeChange"
                >
                  <v-btn
                    v-for="(type, index) in claimTypeList"
                    :key="`claim-type-btn-${index}`"
                    :value="type.id"
                    class="flex-grow-1"
                    depressed
                    :style="getActiveClaimTypeStyle(type)"
                    min-height="40"
                  >
                    {{ type.name }}
                  </v-btn>
                </v-btn-toggle>
              </v-card>
              <perfect-scrollbar
                :options="{ suppressScrollX: true }"
                class="scroll custom-box-top-inner-shadow product-create-heigh"
                style="position: relative; height: calc(100vh - 190px)"
              >
                <v-form
                  ref="createQuotationForm"
                  v-model.trim="formValid"
                  lazy-validation
                  v-on:submit.stop.prevent="onSubmit()"
                >
                  <v-container fluid class="py-0 px-1">
                    <v-row>
                      <v-col cols="12">
                        <v-card class="rounded pa-4">
                          <div class="text-h6">Claim Information</div>

                          <v-row dense>
                            <v-col cols="12" md="4">
                              <label for="claim-title" class="required"
                                >Title</label
                              >
                              <TextField
                                id="claim-title"
                                v-model="dbClaim.title"
                                :rules="[
                                  validateRules.required(
                                    dbClaim.title,
                                    'Title'
                                  ),
                                ]"
                                dense
                                filled
                                solo
                                flat
                                counter="150"
                                color="cyan"
                                placeholder="Title"
                                :maxlength="250"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="4"
                              v-if="Number(dbClaim.claim_type) === 1"
                            >
                              <label for="select-project" class="required"
                                >Select Project Jobs</label
                              >
                              <v-autocomplete
                                id="select-project"
                                v-model="dbClaim.project_id"
                                :items="projectList"
                                :loading="pageLoading"
                                :rules="[
                                  validateRules.required(
                                    dbClaim.project_id,
                                    'Project'
                                  ),
                                ]"
                                :disabled="pageLoading"
                                dense
                                filled
                                solo
                                flat
                                attach
                                color="cyan"
                                item-text="name"
                                item-value="id"
                                item-color="cyan"
                                placeholder="Select Project"
                                hide-details
                                @change="onProjectChange"
                              />
                            </v-col>
                            <v-col cols="12" md="4">
                              <label for="Choose-Approver" class="required"
                                >Choose Approver</label
                              >
                              <v-autocomplete
                                id="Choose-Approver"
                                v-model.trim="dbClaim.user_id"
                                :items="userList"
                                :loading="pageLoading"
                                :disabled="pageLoading"
                                :rules="[
                                  validateRules.required(
                                    dbClaim.user_id,
                                    'Approver'
                                  ),
                                ]"
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                                item-text="display_name"
                                item-value="id"
                                item-color="cyan"
                                placeholder="Choose Approver"
                                hide-details
                              >
                                <template v-slot:no-data>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        No Choose Approver Found.
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="4">
                              <label for="select-employee" class="required">
                                Employee</label
                              >
                              <v-autocomplete
                                id="select-employee"
                                v-model.trim="dbClaim.employee_id"
                                :items="filteredTechnicianList"
                                :rules="[
                                  validateRules.required(
                                    dbClaim.employee_id,
                                    'Employee'
                                  ),
                                ]"
                                :loading="pageLoading"
                                :disabled="
                                  pageLoading ||
                                  isSelfEmployeeRestrictionEnabled()
                                "
                                :readonly="isSelfEmployeeRestrictionEnabled()"
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                                item-text="display_name"
                                item-value="id"
                                item-color="cyan"
                                :search-input.sync="employeeSearch"
                                :filter="() => true"
                                :placeholder="
                                  isSelfEmployeeRestrictionEnabled()
                                    ? selectedEmployee?.display_name ||
                                      'Employee'
                                    : 'Select Employee'
                                "
                                hide-details
                              >
                                <template v-slot:no-data>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        No Select Employee Found.
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col
                              cols="12"
                              md="4"
                              v-if="Number(dbClaim.claim_type) === 2"
                            >
                              <label for="select-visit" class="required">
                                Select Contract Visit
                              </label>

                              <v-autocomplete
                                id="select-visit"
                                v-model.trim="dbClaim.visit"
                                :items="filteredVisitList"
                                :loading="pageLoading"
                                :disabled="pageLoading || !dbClaim.employee_id"
                                :rules="[
                                  validateRules.required(
                                    dbClaim.visit,
                                    'Visit'
                                  ),
                                ]"
                                dense
                                filled
                                solo
                                flat
                                :menu-props="{ offsetY: true }"
                                color="cyan"
                                item-text="label"
                                item-value="id"
                                item-color="cyan"
                                :search-input.sync="visitSearch"
                                :filter="() => true"
                                placeholder="Select Visit"
                                hide-details
                              >
                                <template v-slot:no-data>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        No eligible contract visit found.
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="8" v-if="false">
                              <label class="required d-block">Job Type</label>
                              <RadioInputCustom
                                v-model="dbClaim.job_type"
                                row
                                :items="[
                                  { label: 'Project Job', value: 1 },
                                  { label: 'Service Contract Job', value: 2 },
                                ]"
                              />
                            </v-col>
                          </v-row>
                        </v-card>

                        <v-card class="rounded pa-4 mt-4">
                          <div class="text-h6">Payment Details</div>

                          <v-row>
                            <v-col cols="12" md="4">
                              <label class="required">Claim Category</label>
                              <v-autocomplete
                                v-model.trim="dbClaim.claim_category"
                                :items="claimCategoryList"
                                :disabled="!dbClaim.employee_id"
                                :rules="[
                                  validateRules.required(
                                    dbClaim.claim_category,
                                    'Claim Category'
                                  ),
                                ]"
                                dense
                                filled
                                solo
                                flat
                                item-text="claim_type"
                                item-value="claim_type"
                                placeholder="Claim Category"
                                hide-details
                              />
                            </v-col>

                            <v-col cols="12" md="4">
                              <label>Sub Category</label>
                              <v-autocomplete
                                v-model.trim="dbClaim.claim_sub_category"
                                :items="claimSubCategoryList"
                                dense
                                filled
                                solo
                                flat
                                item-text="name"
                                item-value="name"
                                placeholder="Sub Category"
                                hide-details
                              />
                            </v-col>

                            <v-col cols="12" md="4">
                              <label>Payment Mode</label>
                              <v-autocomplete
                                v-model.trim="dbClaim.payment_mode"
                                :items="paymentModes"
                                dense
                                filled
                                solo
                                flat
                                item-text="name"
                                placeholder="Payment Mode"
                                hide-details
                              />
                            </v-col>

                            <v-col cols="12" md="4">
                              <label class="required">Receipt Amount</label>
                              <div class="d-flex align-center">
                                <v-text-field
                                  v-model.number="dbClaim.receipt_amount"
                                  dense
                                  filled
                                  solo
                                  flat
                                  type="number"
                                  :max="categoryDetails.remaining_amount"
                                  :rules="[
                                    validateRules.required(
                                      dbClaim.receipt_amount,
                                      'Receipt Amount'
                                    ),
                                  ]"
                                  placeholder="0.00"
                                  @input="validateReceiptLimit"
                                />
                              </div>
                            </v-col>

                            <v-col cols="12" md="4">
                              <label class="required">Receipt Date</label>
                              <DatePicker
                                v-model="dbClaim.date"
                                :default-date="dbClaim.date"
                                solo
                                flat
                                @change="updateDuration"
                              />
                            </v-col>

                            <v-col cols="12" md="4">
                              <label>Receipt Number</label>
                              <TextField
                                id="receipt-number"
                                v-model="dbClaim.receipt_number"
                                dense
                                type="number"
                                filled
                                solo
                                flat
                                counter="50"
                                color="cyan"
                                placeholder="Enter Receipt Number"
                              />
                            </v-col>
                          </v-row>
                        </v-card>

                        <v-card class="rounded pa-4 mt-4">
                          <div class="text-h6">Description</div>
                          <TextAreaField
                            v-model.trim="dbClaim.description"
                            auto-grow
                            dense
                            filled
                            solo
                            flat
                            color="cyan"
                            row-height="25"
                            counter="250"
                            placeholder="Description"
                          />
                        </v-card>

                        <v-card class="rounded pa-4 mt-4">
                          <v-row>
                            <v-col cols="12" md="6">
                              <div class="required text-h6">Reason</div>
                              <TextAreaField
                                v-model.trim="dbClaim.resion"
                                auto-grow
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                                row-height="54"
                                counter="250"
                                placeholder="Reason for Claim"
                              />
                            </v-col>

                            <v-col cols="12" md="6">
                              <div class="text-h6">Receipt</div>
                              <DocumnetList
                                v-model="dbClaim.receipt_attachments"
                                :document-type="2"
                              />
                            </v-col>
                          </v-row>
                        </v-card>

                        <v-card class="rounded pa-4 mt-4 mb-10">
                          <DocumnetList
                            v-model="dbClaim.claim_attachments"
                            :document-type="3"
                          />
                        </v-card>

                        <entity-select
                          :dialog="vEntityDialog"
                          @close="closeEntityDialog"
                          @sucess="resetData"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </perfect-scrollbar>
            </v-container>
          </v-layout>
        </v-col>
      </v-row>
    </template>
  </CreateUpdateTemplate>
</template>

<script>
// import FileUpload from "@/view/components/app-component/FileInput";
import RadioInputCustom from "@/view/components/RadioInputCustom.vue";
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ValidationMixin from "@/core/plugins/validation-mixin";
import moment from "moment-timezone";
import ObjectPath from "object-path";
import { SET_ENTITY } from "@/core/services/store/entity.module";

import { QUERY, POST, PATCH } from "@/core/services/store/request.module";
import { currentUser } from "@/core/services/jwt.service";

import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import KTCookie from "@/assets/js/components/cookie";
import DocumnetList from "@/view/pages/DocumnetList";
import TextAreaField from "@/view/components/app-component/TextAreaField.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import EntityMixin from "@/core/plugins/entity-mixin";
import DatePicker from "@/view/pages/partials/Datepicker.vue";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "create-claim",
  mixins: [ValidationMixin, CommonMixin, EntityMixin],
  data() {
    return {
      routePreventDialog: false,
      claimSubCategoryList: [],
      claimCategoryList: [],
      projectList: [],
      visitList: [],
      paymentModes: [],

      pageLoading: false,
      formLoading: false,
      formValid: true,
      claimCreated: false,
      receipt_attachments: [],
      resion: null,
      claim_Id: 0,
      employeeSearch: "",
      visitSearch: "",
      employeeSearchTimeout: null,
      visitSearchTimeout: null,
      dropdownLimit: 10,

      dbClaim: {
        id: null,
        barcode: null,
        payment_mode: null,
        job_type: 1,
        entity_id: null,
        title: null,
        description: null,
        claim_type: null,
        claim_category: null,
        claim_sub_category: null,
        // sales: null,
        project: null,
        project_id: null,
        visit: null,
        receipt_attachments: [],
        claim_attachments: [],
      },
      categoryDetails: {
        max_amount: 0,
        total_claimed: 0,
        remaining_amount: 0,
        color: null,
      },
      claimTypeList: [
        { id: 1, name: "Project Job" },
        { id: 2, name: "Service Contract Job" },
      ],
      userList: [],
      technicianList: [],
      claimOptionUser: null,
      todayDate: null,
    };
  },
  components: {
    TextAreaField,
    CreateUpdateTemplate,
    DocumnetList,
    DatePicker,
    RadioInputCustom,
  },
  methods: {
    onClaimTypeChange(value) {
      const claimType = Number(value);

      if (![1, 2].includes(claimType)) return;

      this.dbClaim.job_type = claimType;
      this.dbClaim.claim_type = claimType;

      if (!this.isEditMode) {
        if (claimType === 1) {
          this.dbClaim.visit = null;
        }

        if (claimType === 2) {
          this.dbClaim.project = null;
          this.dbClaim.project_id = null;
        }
      }
    },
    onProjectChange(projectId) {
      const selectedProject = this.projectList.find(
        (project) => Number(project.id) === Number(projectId)
      );

      this.dbClaim.project_id = projectId ? Number(projectId) : null;

      this.dbClaim.project = selectedProject ? selectedProject.name : null;
    },
    resetData(entity) {
      if (entity && entity.id) {
        this.dbClaim.entity_id = entity.id;

        this.$store.dispatch(SET_ENTITY, entity);

        this.reEntity = entity;
      }
    },
    validateReceiptLimit(value) {
      const maxAmount = Number(this.categoryDetails.max_amount || 0);
      const totalClaimed = Number(this.categoryDetails.total_claimed || 0);
      const available = maxAmount - totalClaimed;

      if (Number(value) > available) {
        this.dbClaim.receipt_amount = null;
        ErrorEventBus.$emit(
          "update:error",
          `Receipt Amount cannot exceed the Claim Category maximum amount of RM ${available.toFixed(
            2
          )}.`
        );
      }
    },
    async fetchCategoryDetails(categoryId) {
      if (!this.dbClaim.employee_id) return;

      try {
        const payload = {
          employee_id: this.dbClaim.employee_id,
          category_id: categoryId,
          claim_date: this.dbClaim.date,
          claim_id: this.dbClaim.id || null,
          visit: this.dbClaim.visit || null,
        };

        const response = await this.$store.dispatch(QUERY, {
          url: "claim/category-details",
          data: payload,
        });

        const data = response.data;

        if (!data) {
          console.error("No category data found");
          return;
        }

        this.categoryDetails = {
          max_amount: Number(data.max_amount || 0),
          total_claimed: Number(data.total_claimed || 0),
          remaining_amount: Number(data.remaining_amount || 0),
          color: data.color || null,
          draft_exists: data.draft_exists || false,
        };
        if (this.categoryDetails.draft_exists) {
          ErrorEventBus.$emit(
            "update:error",
            "A draft claim already exists for this category this month."
          );
        }
      } catch (error) {
        console.error("Failed to fetch category details:", error);
      }
    },

    getClaimTypeName() {
      const type = this.claimTypeList.find(
        (t) => Number(t.id) === Number(this.dbClaim.claim_type)
      );
      return type ? type.name : null;
    },
    getCurrentUserRole() {
      return Number(
        this.claimOptionUser?.user_role ??
          this.currentUser?.role ??
          currentUser()?.role ??
          0
      );
    },
    getCurrentUserId() {
      const user =
        this.claimOptionUser || this.currentUser || currentUser() || {};
      const engineerId = Number(
        user.engineer ?? user.engineer_id ?? user.employee_id ?? 0
      );

      if (engineerId > 0) {
        return engineerId;
      }

      return Number(user.user_id ?? user.id ?? 0);
    },
    isSelfEmployeeRestrictionEnabled() {
      return [2, 3].includes(this.getCurrentUserRole());
    },
    applyEmployeeRoleRestriction() {
      const currentUserId = this.getCurrentUserId();

      if (!currentUserId || !this.isSelfEmployeeRestrictionEnabled()) return;

      if (this.claim_Id && this.dbClaim.employee_id) return;

      this.dbClaim.employee_id = currentUserId;

      const hasCurrentUserInList = this.technicianList.some(
        (tech) => Number(tech.id) === currentUserId
      );

      if (hasCurrentUserInList) return;

      const currentUserData =
        this.claimOptionUser || this.currentUser || currentUser() || {};

      this.technicianList.unshift({
        ...currentUserData,
        id: currentUserId,
        display_name:
          currentUserData.display_name ||
          currentUserData.user_name ||
          currentUserData.name ||
          "Current User",
        primary_email:
          currentUserData.primary_email ||
          currentUserData.user_email ||
          currentUserData.email ||
          "—",
        primary_phone:
          currentUserData.primary_phone ||
          currentUserData.phone_number ||
          currentUserData.phone ||
          "—",
      });
    },
    formatDetailDate(date) {
      return date ? moment(date).format("DD MMM YYYY") : "—";
    },
    getAssignedTechnicianIds(visit) {
      if (!visit?.engineers) return [];

      let assignedEngineers = visit.engineers;
      if (typeof assignedEngineers === "string") {
        try {
          assignedEngineers = JSON.parse(assignedEngineers);
        } catch {
          return [];
        }
      }

      if (!Array.isArray(assignedEngineers)) {
        assignedEngineers = assignedEngineers ? [assignedEngineers] : [];
      }

      return [
        ...new Set(
          assignedEngineers
            .flatMap((engineer) => {
              if (!engineer || typeof engineer !== "object") return [engineer];

              return [
                engineer.id,
                engineer.engineer_id,
                engineer.employee_id,
                engineer.user,
                engineer.user_id,
                engineer.engineer?.id,
                engineer.engineer?.user,
                engineer.engineer?.user_id,
                engineer.employee?.id,
                engineer.employee?.user,
                engineer.employee?.user_id,
              ];
            })
            .map(Number)
            .filter((id) => id > 0)
        ),
      ];
    },
    fetchEmployeeOptions(search = "") {
      const entityId = Number(this.dbClaim.entity_id || this.reEntityId || 0);
      let selectedEmployeeId = Number(this.dbClaim.employee_id || 0);

      if (!selectedEmployeeId && this.isSelfEmployeeRestrictionEnabled()) {
        selectedEmployeeId = this.getCurrentUserId();
        this.dbClaim.employee_id = selectedEmployeeId || null;
      }

      const previousList = Array.isArray(this.technicianList)
        ? this.technicianList
        : [];

      this.pageLoading = true;

      return this.$store
        .dispatch(QUERY, {
          url: "claim-engineer-list",
          data: {
            entity: entityId,
            search: search || "",
            limit: this.dropdownLimit,
            value: selectedEmployeeId,
          },
        })
        .then(({ data }) => {
          const list = (Array.isArray(data) ? data : []).map((item) => ({
            ...item,
            id: Number(item.id),
            display_name:
              item.display_name ||
              item.full_name ||
              [item.first_name, item.last_name].filter(Boolean).join(" ") ||
              "Engineer",
            label:
              item.display_name ||
              item.full_name ||
              [item.first_name, item.last_name].filter(Boolean).join(" ") ||
              "Engineer",
          }));

          if (selectedEmployeeId) {
            const exists = list.some(
              (item) => Number(item.id) === selectedEmployeeId
            );

            if (!exists) {
              const currentEmployee = previousList.find(
                (item) => Number(item.id) === selectedEmployeeId
              );

              if (currentEmployee) {
                list.unshift({
                  ...currentEmployee,
                  display_name:
                    currentEmployee.display_name ||
                    currentEmployee.full_name ||
                    [currentEmployee.first_name, currentEmployee.last_name]
                      .filter(Boolean)
                      .join(" ") ||
                    "Engineer",
                  label:
                    currentEmployee.display_name ||
                    currentEmployee.full_name ||
                    [currentEmployee.first_name, currentEmployee.last_name]
                      .filter(Boolean)
                      .join(" ") ||
                    "Engineer",
                });
              }
            }
          }

          this.technicianList = list;
          return list;
        })
        .catch((error) => {
          console.error("Failed to fetch employee options:", error);
          return [];
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    fetchVisitOptions(search = "") {
      const entityId = Number(this.dbClaim.entity_id || this.reEntityId || 0);
      let employeeId = Number(this.dbClaim.employee_id || 0);
      const selectedVisitId = Number(this.dbClaim.visit || 0);
      const previousList = Array.isArray(this.visitList) ? this.visitList : [];

      if (!employeeId && this.isSelfEmployeeRestrictionEnabled()) {
        employeeId = this.getCurrentUserId();
        this.dbClaim.employee_id = employeeId || null;
      }

      if (Number(this.dbClaim.claim_type) !== 2 || !entityId || !employeeId) {
        this.visitList = [];
        return Promise.resolve([]);
      }

      return this.$store
        .dispatch(QUERY, {
          url: "claim-visit-list",
          data: {
            entity: entityId,
            employee_id: employeeId,
            search: search || "",
            limit: this.dropdownLimit,
            value: selectedVisitId,
          },
        })
        .then(({ data }) => {
          const list = (Array.isArray(data) ? data : []).map((item) => {
            const barcode = item.barcode || "";
            const title = item.title || item.label || item.display_name || "";

            return {
              ...item,
              id: Number(item.id),
              label:
                [barcode, title].filter(Boolean).join(" - ") ||
                `Visit ${item.id}`,
              display_name:
                [barcode, title].filter(Boolean).join(" - ") ||
                `Visit ${item.id}`,
            };
          });

          if (selectedVisitId) {
            const exists = list.some(
              (item) => Number(item.id) === selectedVisitId
            );
            if (!exists) {
              const currentVisit =
                previousList.find(
                  (item) => Number(item.id) === selectedVisitId
                ) ||
                (this.dbClaim.visit
                  ? {
                      id: Number(this.dbClaim.visit),
                      barcode: this.dbClaim.visit_barcode,
                      title: this.dbClaim.visit_title,
                      label: this.dbClaim.visit_title,
                      display_name: this.dbClaim.visit_title,
                    }
                  : null);

              if (currentVisit) {
                list.unshift({
                  ...currentVisit,
                  id: Number(currentVisit.id),
                  label:
                    [
                      currentVisit.barcode,
                      currentVisit.title ||
                        currentVisit.label ||
                        currentVisit.display_name,
                    ]
                      .filter(Boolean)
                      .join(" - ") || `Visit ${currentVisit.id}`,
                  display_name:
                    [
                      currentVisit.barcode,
                      currentVisit.title ||
                        currentVisit.label ||
                        currentVisit.display_name,
                    ]
                      .filter(Boolean)
                      .join(" - ") || `Visit ${currentVisit.id}`,
                });
              }
            }
          }

          this.visitList = list;
          return list;
        })
        .catch((error) => {
          console.error("Failed to fetch visit options:", error);
          return [];
        });
    },
    onEmployeeSearch(searchText) {
      const query = (searchText || "").trim();
      if (this.employeeSearchTimeout) {
        clearTimeout(this.employeeSearchTimeout);
      }
      this.employeeSearchTimeout = setTimeout(() => {
        this.fetchEmployeeOptions(query);
      }, 250);
    },
    onVisitSearch(searchText) {
      const query = (searchText || "").trim();
      if (this.visitSearchTimeout) {
        clearTimeout(this.visitSearchTimeout);
      }
      this.visitSearchTimeout = setTimeout(() => {
        this.fetchVisitOptions(query);
      }, 250);
    },

    updateDuration(claim_start) {
      this.dbClaim.claim_start = claim_start;

      this.$nextTick(() => {
        const { duration_value, duration_type } = this.dbClaim;

        let output = moment(claim_start).add(duration_value, duration_type);
        this.dbClaim.claim_end = moment(output)
          .subtract(1, "day")
          .format("YYYY-MM-DD");
      });
    },

    validateJob(type, action) {
      if (!this.reEntityId) {
        ErrorEventBus.$emit("update:error", "Select Entity");
        return false;
      }

      const validateStatus = this.$refs.createQuotationForm.validate();

      const formErrors = this.validateForm(this.$refs.createQuotationForm);

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
        }
        return false;
      }

      if (validateStatus) {
        this.onSubmit(type, action);
      }
    },
    async onSubmit() {
      const claimType = Number(this.dbClaim.claim_type);
      const projectId = this.dbClaim.project_id
        ? Number(this.dbClaim.project_id)
        : null;
      const payload = {
        ...this.dbClaim,
        // claim_type: selectedType.name,
        job_type: claimType,
        claim_type: this.getClaimTypeName(),
        project: claimType === 1 ? this.dbClaim.project : null,

        project_id: claimType === 1 ? projectId : null,
        visit: claimType === 1 ? null : this.dbClaim.visit,
        receipt_attachments: this.dbClaim.receipt_attachments || [],
        claim_attachments: this.dbClaim.claim_attachments || [],
        // action: type || null,
        // statusapprove: statusAction || null,
      };

      const claimId = Number(this.$route?.query?.edit ?? 0);
      const requestType = claimId ? PATCH : POST;
      const requestURL = claimId ? `claim/${claimId}` : "claim";

      this.formLoading = true;

      try {
        const { data } = await this.$store.dispatch(requestType, {
          url: requestURL,
          data: payload,
        });

        this.claimCreated = true;

        this.$nextTick(() => {
          this.$router.push({
            name: "admin.claim.detail",
            params: { id: data.id },
          });
        });
      } catch (error) {
        console.error("Error saving claim:", error);
        this.formLoading = false;
      }
    },

    getActiveClaimTypeStyle(type) {
      const colors = {
        1: "#00bcd4",
        2: "#4caf50",
      };

      if (this.dbClaim.claim_type == type.id) {
        return {
          color: "#ffffff",
          backgroundColor: colors[type.id],
        };
      }

      return {};
    },
    get_attributes() {
      const editClaimId = ObjectPath.get(this.$route, "query.edit");

      this.$store
        .dispatch(QUERY, {
          url: "claim/options",
          data: {
            claim: editClaimId || null,
            entity_id: this.dbClaim.entity_id || this.reEntityId,
          },
        })
        .then((response) => {
          // this.userList = ObjectPath.get(response, "data.sales_users", []);
          // this.technicianList = ObjectPath.get(
          //   response,
          //   "data.technicians",
          //   []
          // );
          this.userList = ObjectPath.get(response, "data.sales_users", []).map(
            (user) => ({
              ...user,
              id: Number(user.id),
            })
          );

          this.technicianList = [];

          this.claimOptionUser = {
            user_id: ObjectPath.get(response, "data.user_id", null),
            user_name: ObjectPath.get(response, "data.user_name", null),
            user_role: ObjectPath.get(response, "data.user_role", null),
            id: ObjectPath.get(response, "data.user.id", null),
            display_name: ObjectPath.get(
              response,
              "data.user.display_name",
              null
            ),
            ...(ObjectPath.get(response, "data.user", {}) || {}),
          };

          this.applyEmployeeRoleRestriction();

          if (this.isSelfEmployeeRestrictionEnabled()) {
            const restrictedEmployeeId = this.getCurrentUserId();

            if (restrictedEmployeeId) {
              this.dbClaim.employee_id = restrictedEmployeeId;
            }
          }

          this.claimCategoryList = ObjectPath.get(
            response,
            "data.claim_categories",
            []
          );
          // this.projectList = ObjectPath.get(response, "data.projects", []);
          this.projectList = ObjectPath.get(response, "data.projects", []).map(
            (project) => ({
              ...project,
              id: Number(project.id),
            })
          );
          this.visitList = [];
          this.paymentModes = ObjectPath.get(
            response,
            "data.payment_modes",
            []
          );
          this.dbClaim.barcode = ObjectPath.get(response, "data.barcode");
          const dbClaim = ObjectPath.get(response, "data.claim");

          if (dbClaim?.id) {
            this.claim_Id = Number(dbClaim.id);
            this.reEntityId = Number(dbClaim.entity_id);

            const claimType =
              dbClaim.claim_type === "Project Job"
                ? 1
                : dbClaim.claim_type === "Service Contract Job"
                ? 2
                : Number(dbClaim.claim_type);
            const jobType =
              dbClaim.job_type === "Project Job"
                ? 1
                : dbClaim.job_type === "Service Contract Job"
                ? 2
                : Number(dbClaim.job_type);
            this.dbClaim = {
              ...this.dbClaim,
              ...dbClaim,
              claim_type: claimType,
              job_type: jobType,

              // Important: match the autocomplete item-value="id"
              project_id: dbClaim.project_id
                ? Number(dbClaim.project_id)
                : null,
              project: dbClaim.project || null,
              user_id: dbClaim.user_id ? Number(dbClaim.user_id) : null,
              employee_id: dbClaim.employee_id
                ? Number(dbClaim.employee_id)
                : null,
              visit: dbClaim.visit ? Number(dbClaim.visit) : null,
              receipt_attachments: dbClaim.receipt_attachments || [],
              claim_attachments: dbClaim.claim_attachments || [],
            };

            if (
              this.isSelfEmployeeRestrictionEnabled() &&
              !this.dbClaim.employee_id
            ) {
              this.dbClaim.employee_id = Number(
                this.currentUser?.id ?? currentUser()?.id ?? 0
              );
            }

            if (
              Number(this.dbClaim.claim_type) === 2 &&
              this.dbClaim.employee_id
            ) {
              this.$nextTick(() => {
                this.fetchVisitOptions();
              });
            }

            this.$store.dispatch(SET_ENTITY, {
              id: Number(dbClaim.entity_id),
              name: dbClaim.entity_name,
            });

            this.$store.dispatch(SET_BREADCRUMB, [
              { title: "Claim", route: "claim" },
              { title: "Update" },
              { title: this.dbClaim.barcode },
            ]);
          }
        })
        .catch((error) => {
          console.error(error);
          this.goBack();
        });
    },
  },
  watch: {
    reEntityId(newVal, oldVal) {
      if (!this.isEditMode && newVal && newVal !== oldVal) {
        this.dbClaim.entity_id = newVal;
        if (Number(this.$route.query.entity_id) !== Number(newVal)) {
          this.$router.replace({
            path: this.$route.path,
            query: {
              ...this.$route.query,
              entity_id: newVal,
            },
          });
        }
        this.get_attributes();
        this.fetchEmployeeOptions(this.employeeSearch);
      }
    },
    currentUser() {
      if (this.isSelfEmployeeRestrictionEnabled()) {
        this.applyEmployeeRoleRestriction();
      }
    },
    "dbClaim.claim_type"(claimType) {
      const type = Number(claimType);

      if (!this.isEditMode) {
        if (type === 1) {
          this.dbClaim.visit = null;
        }

        if (type === 2) {
          this.dbClaim.project = null;
          this.dbClaim.project_id = null;
        }
      }

      if (type === 2 && this.dbClaim.employee_id) {
        this.fetchVisitOptions();
      }
    },
    "dbClaim.employee_id"() {
      if (Number(this.dbClaim.claim_type) === 2) {
        this.fetchVisitOptions();

        if (this.visitList.length > 0) {
          const selectedVisitIsEligible = this.filteredVisitList.some(
            (visit) => Number(visit.id) === Number(this.dbClaim.visit)
          );

          if (!selectedVisitIsEligible && this.dbClaim.visit) {
            this.dbClaim.visit = null;
          }
        }
      }

      const category = this.claimCategoryList.find(
        (item) => item.claim_type === this.dbClaim.claim_category
      );
      if (category && this.dbClaim.employee_id) {
        this.fetchCategoryDetails(category.id);
      }
    },
    employeeSearch(newVal) {
      this.onEmployeeSearch(newVal);
    },
    visitSearch(newVal) {
      this.onVisitSearch(newVal);
    },

    "dbClaim.claim_category"(categoryName) {
      const category = this.claimCategoryList.find(
        (c) => c.claim_type === categoryName
      );

      this.claimSubCategoryList = category?.sub_categories || [];
      if (!this.isEditMode) {
        this.dbClaim.claim_sub_category = null;
      }

      if (this.dbClaim.employee_id && category) {
        this.fetchCategoryDetails(category.id);
      }
    },
  },
  mounted() {
    this.$refs.createQuotationForm.validate();

    this.claim_Id = Number(this.$route?.query?.edit ?? 0);

    const entityId = Number(this.$route?.query?.entity_id ?? 0);
    if (entityId > 0) {
      this.reEntityId = entityId;
      this.dbClaim.entity_id = entityId;
      this.$store.dispatch(SET_ENTITY, { id: entityId }).catch((error) => {
        console.log("Error loading entity:", error);
      });
    }
    this.get_attributes();
    this.fetchEmployeeOptions(this.employeeSearch);
    this.applyEmployeeRoleRestriction();
    this.$store.dispatch(SET_BREADCRUMB, []);
  },

  beforeDestroy() {
    KTCookie.setCookie("kt_aside_toggle_state", "off");
    localStorage.setItem("kt_aside_toggle_state", "off");
  },
  created() {
    this.todayDate = moment().format("YYYY-MM-DD");
    this.dbClaim.date = this.todayDate;
    this.dbClaim.invoice_date = this.todayDate;
    this.dbClaim.enquiry = this.lodash.toSafeInteger(
      ObjectPath.get(this.$route, "query.enquiry")
    );
  },
  beforeCreate() {
    KTCookie.setCookie("kt_aside_toggle_state", "on");
    localStorage.setItem("kt_aside_toggle_state", "on");
  },
  computed: {
    ...mapGetters([
      "vSelectedLineItem",
      "vCalculations",
      "vEntityDialog",
      "reEntity",
      "currentUser",
    ]),
    reEntityId: {
      get() {
        return this.$store.getters.reEntityId;
      },
      set(val) {
        if (!val) {
          return;
        }

        this.$store.dispatch(SET_ENTITY, { id: Number(val) }).catch((error) => {
          console.log("Error loading entity:", error);
        });
      },
    },
    // isSuperAdmin() {
    //   return this.currentUser?.role === "super_admin";
    // },
    filteredTechnicianList() {
      const list = this.technicianList || [];
      const currentUserId = Number(
        this.currentUser?.id ?? currentUser()?.id ?? 0
      );
      const baseList =
        !this.isSelfEmployeeRestrictionEnabled() || !currentUserId
          ? list
          : list.filter((tech) => Number(tech.id) === currentUserId);

      const selectedEmployeeId = Number(this.dbClaim.employee_id || 0);
      const selected = baseList.filter(
        (item) => Number(item.id) === selectedEmployeeId
      );

      return [
        ...selected,
        ...baseList.filter((item) => Number(item.id) !== selectedEmployeeId),
      ].slice(0, this.dropdownLimit);
    },
    selectedEmployee() {
      const currentUserData =
        this.claimOptionUser || this.currentUser || currentUser() || {};
      const currentUserId = Number(this.getCurrentUserId());

      const matchedEmployee = this.technicianList.find(
        (tech) => Number(tech.id) === Number(this.dbClaim.employee_id)
      );

      if (matchedEmployee) {
        return {
          ...matchedEmployee,
          ...currentUserData,
          display_name:
            matchedEmployee.display_name ||
            currentUserData.display_name ||
            currentUserData.user_name ||
            currentUserData.name ||
            "Current User",
          primary_email:
            matchedEmployee.primary_email ||
            currentUserData.primary_email ||
            currentUserData.user_email ||
            currentUserData.email ||
            "—",
          primary_phone:
            matchedEmployee.primary_phone ||
            currentUserData.primary_phone ||
            currentUserData.phone_number ||
            currentUserData.phone ||
            "—",
        };
      }

      if (Number(this.dbClaim.employee_id) === currentUserId) {
        return {
          ...currentUserData,
          id: currentUserId,
          display_name:
            currentUserData.display_name ||
            currentUserData.user_name ||
            currentUserData.name ||
            "Current User",
          primary_email:
            currentUserData.primary_email ||
            currentUserData.user_email ||
            currentUserData.email ||
            "—",
          primary_phone:
            currentUserData.primary_phone ||
            currentUserData.phone_number ||
            currentUserData.phone ||
            "—",
        };
      }

      return null;
    },
    entityName() {
      return (
        this.dbClaim.entity_name ||
        this.reEntity?.name ||
        this.$store.getters.currentEntity?.name ||
        "Select an Entity"
      );
    },
    availableAmount() {
      const maxAmount = Number(this.categoryDetails.max_amount || 0);
      const totalClaimed = Number(this.categoryDetails.total_claimed || 0);
      const receiptAmount = Number(this.dbClaim.receipt_amount || 0);

      const available = maxAmount - totalClaimed - receiptAmount;

      return available > 0 ? available.toFixed(2) : "0.00";
    },

    isEditMode() {
      return this.claim_Id > 0;
    },
    selectedUser() {
      return (
        this.userList.find(
          (user) => Number(user.id) === Number(this.dbClaim.user_id)
        ) || null
      );
    },
    selectedVisit() {
      return (
        this.visitList.find(
          (visit) => Number(visit.id) === Number(this.dbClaim.visit)
        ) || null
      );
    },
    visitStatusText() {
      if (!this.selectedVisit) return "—";

      return Number(this.selectedVisit.status) === 2
        ? "In Progress"
        : Number(this.selectedVisit.status) === 4
        ? "Completed"
        : "—";
    },
    selectedProject() {
      return (
        this.projectList.find(
          (project) => Number(project.id) === Number(this.dbClaim.project_id)
        ) || null
      );
    },
    selectedCategory() {
      return (
        this.claimCategoryList.find(
          (cat) => cat.claim_type === this.dbClaim.claim_category
        ) || null
      );
    },
    selectedSubCategory() {
      return (
        this.claimSubCategoryList.find(
          (sub) => sub.name === this.dbClaim.claim_sub_category
        ) || null
      );
    },
    filteredVisitList() {
      const selectedEmployeeId = Number(this.dbClaim.employee_id);
      if (!selectedEmployeeId) return [];

      const list = (this.visitList || []).filter((visit) =>
        this.getAssignedTechnicianIds(visit).includes(selectedEmployeeId)
      );

      const selectedVisitId = Number(this.dbClaim.visit || 0);
      const selected = list.filter(
        (item) => Number(item.id) === selectedVisitId
      );

      return [
        ...selected,
        ...list.filter((item) => Number(item.id) !== selectedVisitId),
      ].slice(0, this.dropdownLimit);
    },
  },

  beforeRouteLeave(to, from, next) {
    const _this = this;
    if (_this.claimCreated) {
      next();
    } else {
      _this.routePreventDialog = true;
      PreventDialogEventBus.$on("stay-on-page", function () {
        _this.routePreventDialog = false;
        next(false);
      });
      PreventDialogEventBus.$on("leave-page", function () {
        _this.routePreventDialog = false;
        next();
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.quotation-create-page {
  border-top: solid 8px #f7941e;

  label {
    padding-left: 5px;
    font-weight: 600;
  }

  p {
    padding-left: 5px;
  }
}
.left-border-green {
  border-left: 5px solid #2e7d32;
}

.left-border-purple {
  border-left: 5px solid #6a1b9a;
}
.left-border-orange {
  border-left: 5px solid #df982f;
}
.left-border-blue {
  border-left: 5px solid #2196f3;
}

.form-action {
  display: flex;
  justify-content: space-between;

  .form-title {
    font-size: 24px;
    font-family: "Poppins", Helvetica, Arial, sans-serif;
    font-weight: 700;
    color: #24326d;
    letter-spacing: 1.5px;
    line-height: 1.11em;

    .form-title-link {
      color: #4d6974;
      border-bottom: dashed 2px #4d6974;
    }
  }
}
</style>
